module.exports = __webpack_public_path__ + "img/blend.43ec527c.svg";